import axios from 'axios'

export const getUserProfile = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/users/profile",//159.89.236.159
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const setUserProfile = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "/api/v1/users/profile",//159.89.236.159
            data: values,
            headers: {
                'Content-Type': 'multipart/form-data',
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const getMyBookings = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/myBookings",//159.89.236.159
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const getMyRidesBookings = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/myRidesBookings",//159.89.236.159
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const getMyRides = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/myRides",//159.89.236.159
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const setProfileImage = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "/api/v1/users/image",//159.89.236.159
            data: values,
            headers: {
                'Content-Type': 'multipart/form-data',
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const getOwner = (values) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/ownerDetail",//159.89.236.159
            params: values
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const getTransactions = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/users/transaction",//159.89.236.159
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}

export const getStripeDashboardLink = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "/api/v1/users/stripe-connect/dashboard",
            data: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}